<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocPreviewProfilExpert'
});
</script>
<template>
  <ka-container
    code="bloc-preview-profil-expert"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="entreprise">
      <span v-html="componentInstance.$enttreprise.value" />
    </ka-text>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        imgFit: `cover`
      }"
      :value="componentInstance.$image.value" />
    <ka-text
      code="poste"
      :value="componentInstance.$poste.value" />
    <ka-text
      code="prenom"
      :value="componentInstance.$firstName.value" />
    <ka-list
      code="tags-profil-expert-list"
      :options="{
        placeholder: t('blocPreviewProfilExpert.tagsProfilExpertList.placeholder', `No items`),
        debounce: 0,
        entity: `Kapix.Entity.ITagsExperts`,
        items: componentInstance.$tags.value
      }"
      :data="componentInstance.$info.tagsProfilExpertList">
      <template #item="listItemProps">
        <EntitiesTagsExpertsTestProfilsExperts
          :tags-experts="listItemProps.item"
          :options="listItemProps.options" />
      </template>
    </ka-list>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocPreviewProfilExpertComponent } from './store'
import EntitiesTagsExpertsTestProfilsExperts from '~/components/Entities/TagsExperts/TestProfilsExperts/index.vue'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c23')
const component = blocPreviewProfilExpertComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  tags: PartialEntities<Kapix.Entity.ITagsExperts>
  poste?: Nullable<string>
  firstName?: Nullable<string>
  enttreprise?: Nullable<string>
  image?: Nullable<string | File>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  tags: () => [
    { Nom: 'Bacon' },
    { Nom: 'Pizza' },
    { Nom: 'Shirt' },
    { Nom: 'Keyboard' },
    { Nom: 'Shirt' },
    { Nom: 'Table' },
    { Nom: 'Salad' }
  ],
  poste: 'Poste',
  firstName: 'Prénom',
  enttreprise: '&#64;Matchers',
  image: 'https://ucarecdn.com/617b7b84-fc8f-4290-9786-4caaceef0f79/',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:tags',
  'update:poste',
  'update:firstName',
  'update:enttreprise',
  'update:image'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    tags: true,
    poste: true,
    firstName: true,
    enttreprise: true,
    image: true
  }
})
</script>
